export default "__VITE_ASSET__DVT6OMxY__"